import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "ergebnis-liste" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "infotext" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "infotext" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "infotext" }
const _hoisted_12 = { class: "tags mt-2" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "visually-hidden" }
const _hoisted_15 = {
  key: 1,
  class: "float-end"
}
const _hoisted_16 = { class: "consistent-width" }
const _hoisted_17 = { class: "consistent-width" }
const _hoisted_18 = { class: "consistent-width" }
const _hoisted_19 = {
  key: 1,
  id: "ergebnis-liste"
}
const _hoisted_20 = { class: "eintrag--kontakt" }
const _hoisted_21 = { class: "eintrag-title" }
const _hoisted_22 = { class: "eintrag-info" }
const _hoisted_23 = { class: "eintrag-adresse" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  key: 0,
  class: "float-right onb-contact--link--chat"
}
const _hoisted_26 = ["aria-label"]
const _hoisted_27 = {
  key: 1,
  class: "float-right onb-contact--link--video"
}
const _hoisted_28 = ["aria-label"]
const _hoisted_29 = {
  key: 2,
  href: "#",
  class: "float-right onb-contact--link--mail"
}
const _hoisted_30 = ["aria-label"]
const _hoisted_31 = { key: 2 }
const _hoisted_32 = {
  key: 0,
  class: "mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, [
      _createTextVNode(_toDisplayString(_ctx.lcCenter.length) + " " + _toDisplayString(_ctx.$t('searchlist.heading')) + " ", 1),
      (_ctx.region.length > 0 && _ctx.regionsText)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            (_ctx.orderBy == 'ort')
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('searchlist.area')), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, "in")),
            _createTextVNode(" " + _toDisplayString(_ctx.getRegionName(_ctx.getLastRegion())), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.lcCenter && _ctx.lcCenter.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_ctx.orderBy == 'ort')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('searchlist.regionSearch')) + " " + _toDisplayString(_ctx.radiusMap) + " km - " + _toDisplayString(_ctx.$t('searchlist.regionInfo')), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.orderBy == 'bund')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('searchlist.sorting')) + " " + _toDisplayString(_ctx.$t('searchlist.plz')), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "ergebnis-liste-tags",
      style: _normalizeStyle([{"min-height":"45px"}, (!_ctx.mini && _ctx.listTopics.length > 0 ? 'margin-bottom:70px;' : '')])
    }, [
      (!_ctx.mini && _ctx.listTopics.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('searchlist.selectedTopics')) + ":", 1),
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTopics, (topic, index) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: index,
                  class: "btn tag tag-with-close text-break",
                  onClick: ($event: any) => (_ctx.deleteTopic(topic))
                }, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('searchlist.deleteTag')), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.getNameById(topic)), 1)
                ], 8, _hoisted_13))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.lcCenter && _ctx.lcCenter.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('searchlist.chat')), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('searchlist.beratung')), 1)
            ]),
            _createElementVNode("span", _hoisted_17, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('searchlist.video')), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('searchlist.beratung')), 1)
            ]),
            _createElementVNode("span", _hoisted_18, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('searchlist.mail')), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('searchlist.beratung')), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ], 4),
    (_ctx.lcCenter && _ctx.lcCenter.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lcCenter, (center, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "ergebnis-liste-eintrag",
              key: index
            }, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_router_link, {
                    to: {
              name: 'counseling-center',
              params: { ccid: center.id, topics: _ctx.topics, region: _ctx.region, lang: _ctx.lang, cType: _ctx.cType, targetGroup: _ctx.targetGroup, backlink: 'y' }
            }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(center.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _createElementVNode("div", _hoisted_22, _toDisplayString(center.legalEntities[0]?.name), 1),
                _createElementVNode("div", _hoisted_23, [
                  _createTextVNode(_toDisplayString(center.address.zipCode) + " " + _toDisplayString(center.address.city), 1),
                  (center.address && (center.address.streetName || center.address.houseNumber || center.address.addressSupplement))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, ", "))
                    : _createCommentVNode("", true),
                  _createTextVNode(_toDisplayString(center.address.streetName) + " " + _toDisplayString(center.address.houseNumber) + " " + _toDisplayString(center.address.addressSupplement), 1)
                ])
              ]),
              (center.chatCounselingSystem && center.chatCounselingSystem !== 'NONE')
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("i", {
                      class: "icon onb-contact--chat",
                      "aria-label": `die Beratungsstelle ${center.name} bietet Chat-Beratung an`,
                      tabindex: "0"
                    }, null, 8, _hoisted_26)
                  ]))
                : _createCommentVNode("", true),
              (center.videoCounselingSystem && center.videoCounselingSystem !== 'NONE')
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("i", {
                      class: "icon onb-contact--video",
                      "aria-label": `die Beratungsstelle ${center.name} bietet Video-Beratung an`,
                      tabindex: "0"
                    }, null, 8, _hoisted_28)
                  ]))
                : _createCommentVNode("", true),
              (center.mailCounselingSystem && center.mailCounselingSystem !== 'NONE')
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("i", {
                      class: "icon onb-contact--mail",
                      "aria-label": `die Beratungsstelle ${center.name} bietet Mail-Beratung an`,
                      tabindex: "0"
                    }, null, 8, _hoisted_30)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _createTextVNode(_toDisplayString(_ctx.$t('searchlist.notFound')) + " ", 1),
          ((_ctx.lang && _ctx.lang.length > 0) || (_ctx.cType && _ctx.cType.length > 0) || (_ctx.targetGroup && _ctx.targetGroup.length > 0) || (_ctx.searchTerm && _ctx.searchTerm.length > 0))
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("div", {
                  class: "btn btn-link-custom d-inline-block px-0 mx-0",
                  id: "btn-filter-reset",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.resetFilter()))
                }, _toDisplayString(_ctx.$t('searchlist.resetFilter')), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}